<template>
  <div v-if="reFresh" class="block__card" :class="{ odd: isOdd }">
    <BlockHeader>
      <div slot="month" class="month">{{ month }}月</div>
      <div slot="date" class="date">{{ date }}</div>
      <div slot="day" class="day">周{{ day }}</div>

      <div slot="recent" class="recent">
        <span :class="recent.class">{{ recent.str }}</span>
      </div>
    </BlockHeader>
    <BlockDay :startTime="startTime" />
  </div>
</template>

<script>
import BlockDay from "./BlockDateCardDay";
import BlockHeader from "./BlockDateCardHeader";
import { mapGetters } from "vuex";

export default {
  props: ["startTime"],
  data() {
    return {
      reFresh: true
    };
  },
  components: {
    BlockDay,
    BlockHeader
  },
  computed: {
    month() {
      const months = [..."一二三四五六七八九十", "十一", "十二"];
      const date = new Date(this.startTime);

      return months[date.getMonth()];
    },
    date() {
      return new Date(this.startTime).getDate();
    },
    day() {
      const weekStr = "日一二三四五六";
      return weekStr[new Date(this.startTime).getDay()];
    },
    recent() {
      //TODO: 这可以放到全局state里,省的每次都遍历
      const now = new Date();
      const aDaySize = 24 * 60 * 60 * 1000;
      const toDay = new Date(
        `${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()}`
      ).getTime();
      let result = { class: null, str: null };

      switch (this.startTime) {
        case toDay - aDaySize * 2:
          result = {
            class: "dby",
            str: "前天"
          };
          break;
        case toDay - aDaySize:
          result = {
            class: "yest",
            str: "昨天"
          };
          break;
        case toDay:
          result = {
            class: "today",
            str: "今天"
          };
          break;
        case toDay + aDaySize:
          result = {
            class: "tomr",
            str: "明天"
          };
          break;
        case toDay + aDaySize * 2:
          result = {
            class: "dat",
            str: "后天"
          };
          break;
      }

      return result;
    },
    isOdd() {
      return ((this.startTime - this.originDate) / (24 * 60 * 60 * 1000)) % 2;
    },
    ...mapGetters(["originDate"])
  }
};
</script>

<style>
.scale {
  /* position: absolute; */
  z-index: 1000;
}

.block__card {
  display: inline-block;
  height: 100%;
  /* min-width: 25rem; */
  /* min-width: 14.285%; */
  width: 241.7px;
  border-left: 1px solid #eee;
  border-left-width: 1px;
  border-left-style: solid;
  border-left-color: #eeeeee;
  display: flex;
  align-items: stretch;
  vertical-align: text-top;
  flex-flow: column;
  flex: 0 0 241.7px;
  /* position: absolute;   */
}
.block__card .block__block {
  background-color: #ededed;
}

.block__card.odd .block__block {
  background-color: #e6e6e6;
}
</style>
